import React from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';

const NotFound: React.FC = () => {
    return (
        <div id="warp">
            <Header />
            <section id="containers" className="error_wrap">
                <div className="error404">
                    <div className="img"><img src="/images/etc/ico_error404.png" alt=""></img></div>
                    <div className="txt">
                        <strong className="black f16 lh24">원하시는 페이지를 찾을 수가 없습니다.</strong><br />
                        <p className="mt10 black lh24">찾으시려는 페이지의 주소가 잘못 입력되거나, 주소의 변경 또는 삭제로 인해 현재 사용되지 않는 페이지입니다.</p>
                        <p className="mt10 black lh24">기타 궁금하신 내용은 헬스콜센터 (1588-7524)로 문의해 주시기 바랍니다.</p>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default NotFound;